import {
  PaymentStatus,
  TerminalEventMonitoring,
} from '@lightspeed-payments/payments-terminal-sdk'
import { TerminalModel } from '@lightspeed-payments/payments-terminal-sdk/dist/terminal-event-monitoring'
import { SwiperError } from './lspay.types'
import {
  LSPAY_REFUND_TRANSACTION_STATUS,
  LSPAY_TRANSACTION_STATUS,
  TRANSACTION_TYPE,
} from './lspayConstants'

interface Event {
  terminalMonitoringInstance: TerminalEventMonitoring | null
  terminal: {
    id?: string
    model?: TerminalModel
  }
  intentId?: string // paymentIntentId or setupIntentId
  status?: LSPAY_TRANSACTION_STATUS | LSPAY_REFUND_TRANSACTION_STATUS
  reason?: string
  swiperError?: SwiperError
  transactionType?: TRANSACTION_TYPE
}

export const sendTerminalEvent = ({
  terminalMonitoringInstance,
  intentId,
  terminal,
  reason,
  status,
  swiperError,
  transactionType,
}: Event) => {
  if (!terminalMonitoringInstance) return

  terminalMonitoringInstance.sendEvent('COMPLETE', {
    payment: {
      ...(intentId && { id: intentId }),
      status: status ? mapStatus(status, reason) : 'ERROR',
      ...(reason && { reason }),
    },
    terminal,
    ...(swiperError && {
      error: {
        code: swiperError.code?.toString(),
        message: swiperError.message || '',
      },
    }),
    transactionType,
  })
}

// TODO: Revisit statuses for refunds if need be
const mapStatus = (
  status: LSPAY_TRANSACTION_STATUS | LSPAY_REFUND_TRANSACTION_STATUS,
  reason?: string
): PaymentStatus => {
  switch (status) {
    case LSPAY_TRANSACTION_STATUS.COMPLETED:
    case LSPAY_REFUND_TRANSACTION_STATUS.COMPLETED:
      return 'APPROVED'
    case LSPAY_TRANSACTION_STATUS.CANCELLED:
    case LSPAY_REFUND_TRANSACTION_STATUS.CANCELLED:
      return 'CANCELLED'
    case LSPAY_TRANSACTION_STATUS.DECLINED:
    case LSPAY_REFUND_TRANSACTION_STATUS.DECLINED:
      return processDeclined(reason)
    case LSPAY_TRANSACTION_STATUS.PROCESSING:
    case LSPAY_TRANSACTION_STATUS.AUTHORISED:
    case LSPAY_REFUND_TRANSACTION_STATUS.PROCESSING:
    case LSPAY_REFUND_TRANSACTION_STATUS.CARD_PRESENTED:
      return 'INCOMPLETE'
    default: {
      // This `never` typing will let us know at compile time if we do not handle an existing event type.
      const _exhaustiveCheck: never = status
      return _exhaustiveCheck
    }
  }
}

const processDeclined = (reason?: string): PaymentStatus => {
  // In some cases, we consider sending an error event instead
  if (
    !!reason &&
    [
      'TERMINAL_UNAVAILABLE',
      'TERMINAL_ERROR',
      'STRIPE_API_ERROR',
      'STRIPE_INVALID_REQUEST_ERROR',
      'PAYMENT_METHOD_NOT_AVAILABLE',
    ].includes(reason)
  ) {
    return 'ERROR'
  }

  return 'DECLINED'
}
